import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {InterchangeableComponentDto} from "../_models/interchangeable-component-dto";
import {ServerEndpoints} from "../../../server.endpoints";

@Injectable({
  providedIn: 'root'
})
export class InterchangeableComponentHttpService {
  constructor(@Inject("BASE_URL") private baseUrl: string, private http: HttpClient) {
  }

  list(ids: string[] | undefined) {
    return this.http.post<InterchangeableComponentDto[]>(`${this.baseUrl}${ServerEndpoints.Inventory_InterchangeableComponent_List}`, ids);
  }
}
